<template>
  
    <div class="yingxiao youpin">
        <div class="title">
            <div class="yingxiaoLeft">
                <img src=" ../../../static/index/floor/index11.png" alt="">
            </div>
            <div class="yingxiaoMiddle">
                <div class="center">
                    <!-- <img src="http://frontend.xurigo.com/icon/youpintuijian.png"> -->
                    <span class="big">优选推荐</span>
                </div>
                <span class="small">只推荐适合的</span>
            </div>
            <div class="yingxiaoRight">
                <img src=" ../../../static/index/floor/index12.png" alt="">
            </div>
            
        </div>
        <div class="pro-list">    
            <template v-for="(pItem, index) in productList" v-if="loaded">
                <div :class="'item '+ (index%2==0?'marginright':'')" :style="{width:itemWidth+'px'}" :key="pItem.SkuId">
                    <router-link :to="'/retail/productDetail?skuId='+pItem.SkuId">
                        <img :src="pItem.Images&&pItem.Images.length>0?pItem.Images[0].ImgPath: '/static/unknow.gif'" class="tj-pro-img" :style="{height:itemWidth+'px'}">
                    </router-link>
                    <div class="price">
                        <p>￥<span class="money">{{pItem.SalePriceName}}</span></p>
                        <span class="del">￥{{pItem.PriceName}}</span>
                    </div>
                    <div class="name">{{pItem.Name}}</div>
                </div>
            </template>            
            <div v-if="isShowLastDefault" class="item" :style="{width:itemWidth+'px', marginBottom:0}">
                <img src="/static/index/index-item-default.png" style="display:block;" />
            </div>   
            <template v-if="!loaded">
                <div class="animationFont">
                    <i class="fa fa-spinner loading"></i>
                    <p class="remark">玩命加载中...</p>
                </div>
            </template>
        </div>
        <div class="bottom-line">
            <p class="lineOne"></p>
            <img class="bottomImg" src=" ../static/theend.png" alt="">
            <p class="lineTwo"></p>
        </div>
    </div>  
</template>

<script>
export default {  
    name:'XR-mobile-youpin',
    data() {
        return {
            productList:[],
            itemWidth: document.documentElement.clientWidth * 0.49,
            scrollTop : 0,
            loaded:false,
            loading:false,
            isShowLastDefault:false
        }
    },
    mounted:function(){ 
		this.getNewProduct()	
    },
    methods:{
        setScrollTop:function(val){
            this.scrollTop = val 
        },
        getNewProduct:function(){
            this.loading = true
            if(this.productList.length==0){
                const ths = this
                var json = {type:1, pageIndex:1,pageSize:100}
                this.$post("/Shop/RetailServer/GetServiceProductList",json)
                .then(function(res) {
                    if (res.IsSuccess) {        
                        ths.productList = res.Data
                        ths.isShowLastDefault = ths.productList.length % 2==1?true:false
                        ths.loaded = true  
                    }else{                        
                        ths.loading = false
                    }
                })
                .catch(function(err) {
                    console.log(err);
                });    
            }
        }
    },
    watch:{
        scrollTop(){
            if(!this.loading){               
                if(this.scrollTop>300){
                    //this.getNewProduct()
                }
            }
        }
    }
}
</script>

<style>

.yingxiao.youpin .animationFont{
    padding:50px 0;
    text-align: center;
    background: white;
}
.yingxiao.youpin .loading{    
    width: 24px;
    height: 24px;
    line-height: 24px;
    -webkit-animation: weuiLoading 1s steps(12, end) infinite;
    animation: weuiLoading 1s steps(12, end) infinite;
    font-size: 24px;
    color:#999;
}
.yingxiao.youpin .remark{    
    color:#999;
    padding-top: 10px;
}
.yingxiao.youpin .title {
    display: flex;
    justify-content: center;
    align-items: center;
}
.yingxiao.youpin .title .yingxiaoLeft{
    width: 33%;
    text-align: right;
}
.yingxiao.youpin .title .yingxiaoLeft img{
    width: 27px;
}
.yingxiao.youpin .title .yingxiaoMiddle{
    width: 34%;
    text-align: center;
}
.yingxiao.youpin .title .yingxiaoRight{
    width: 33%;
    text-align: left;
}
.yingxiao.youpin .title .yingxiaoRight img{
    width: 27px;
}
</style>



// WEBPACK FOOTER //
// src/components/index/mobile/youpin/youpin.vue